import React, { Fragment } from 'react';
import ReactSelect from 'components/ReactSelect';
import { DATE_RANGE_CONFIG, getErrorHelperText } from 'consts';
import QueryGrid from 'components/_form/QueryGrid';
import { Controller } from 'react-hook-form';
import { inputVal } from 'tradevan-ui/consts';
import { FormVerify, FormVerifyEnum } from 'enum/FormVerifyEnum';
import MultiSelect from 'components/MultiSelect';
import useSupplierCodeListOpTrs from 'hooks/common/useSupplierCodeListOpTrs';
import useBranchListOpTrs from 'hooks/common/useBranchListOpTrs';
import DateTimeStartEnd from 'components/DateTimeStartEnd';
import { Col, Row } from 'react-bootstrap';
import Checkbox from 'tradevan-ui/Checkbox';
import Input from 'tradevan-ui/Input';
import { EnumMasterSort, EnumRetailerSetup } from 'view/Layout/enum';
import RangeInput from 'components/RangeInput';
import { EnumMaster, EnumQueryConditions } from '../../init';
import { nameMaster, nameMasterSort, propertyOption } from '../../consts';
import { QuerySecionProps } from './type';

const QuerySecion = (props: QuerySecionProps) => {
  const {
    handleReset,
    retailerTypeOption,
    formReturn,
    handleUpdateRetailerSetup,
    _retailerSetup: [retailerSetup],
    _showResult: [, setShowResult],
    handleNoViewedPrintOnChange,
    isNoViewedPrintChecked,
    isNoViewedPrintMessage,
    queryDateOption,
    handleQueryDateOptionChange,
  } = props;

  const {
    control,
    watch,
    setValue,
    formState: { errors },
  } = formReturn;

  const masterErrorsRoot = errors.master;
  const masterSortErrorsRoot = errors.masterSort;
  const master = watch('master');
  const masterSort = watch('masterSort');
  /** 廠編選單 OpTrs */
  const supplierOpTrs = useSupplierCodeListOpTrs(master[EnumMaster.retailerId]);
  /** 分店/倉庫代碼 OpTrs */
  const branchListOpTrs = useBranchListOpTrs(master[EnumMaster.retailerId]);

  return (
    <QueryGrid
      rows={[
        {
          fields: [
            {
              show: !!retailerSetup?.[EnumRetailerSetup.queryConditions]?.[
                EnumQueryConditions.retailerId
              ],
              title: '體系別',
              child: (
                <ReactSelect
                  control={control}
                  {...getErrorHelperText(
                    masterErrorsRoot?.[EnumMaster.retailerId],
                  )}
                  name={nameMaster(EnumMaster.retailerId)}
                  value={inputVal(master[EnumMaster.retailerId])}
                  watchValue={() => watch(nameMaster(EnumMaster.retailerId))}
                  rules={FormVerify[FormVerifyEnum.必填]}
                  options={retailerTypeOption}
                  onChange={(newVal) => {
                    // 體系別更換，除了日期以外都重置為預設值

                    // 1. 保留指定的值
                    const tempMaster = {
                      retailerId: newVal,
                      orderDateBegin: master[EnumMaster.orderDateBegin],
                      orderDateEnd: master[EnumMaster.orderDateEnd],
                      deliverDateBegin: master[EnumMaster.deliverDateBegin],
                      deliverDateEnd: master[EnumMaster.deliverDateEnd],
                      supplierCodeLike: master[EnumMaster.supplierCodeLike],
                    };
                    // 2. 重置form表單，並關閉table
                    handleReset();
                    setShowResult(false);

                    // 3. 將保留的資料塞回master
                    setValue(
                      nameMaster(EnumMaster.retailerId),
                      tempMaster.retailerId,
                    );
                    setValue(
                      nameMaster(EnumMaster.orderDateBegin),
                      tempMaster.orderDateBegin,
                    );
                    setValue(
                      nameMaster(EnumMaster.orderDateEnd),
                      tempMaster.orderDateEnd,
                    );
                    setValue(
                      nameMaster(EnumMaster.deliverDateBegin),
                      tempMaster.deliverDateBegin,
                    );
                    setValue(
                      nameMaster(EnumMaster.supplierCodeLike),
                      tempMaster.supplierCodeLike,
                    );
                    // 更換體系別，重取權限
                    handleUpdateRetailerSetup(newVal);
                  }}
                />
              ),
            },
            { invisible: true },
          ],
        },
        {
          fields: [
            {
              show: retailerSetup?.[EnumRetailerSetup.queryConditions]?.[
                EnumQueryConditions.supplierCode
              ],
              title: '廠編',
              child: (
                <MultiSelect
                  placeholder="可單一選擇或複選"
                  isSearchable
                  {...getErrorHelperText(
                    masterErrorsRoot?.[EnumMaster.supplierCode],
                  )}
                  isClearable
                  control={control}
                  name={nameMaster(EnumMaster.supplierCode)}
                  value={inputVal(master[EnumMaster.supplierCode])}
                  watchValue={() => watch(nameMaster(EnumMaster.supplierCode))}
                  options={supplierOpTrs.options}
                />
              ),
            },
            { invisible: true },
          ],
        },
        {
          fields: [
            {
              show: retailerSetup?.[EnumRetailerSetup.queryConditions]?.[
                EnumQueryConditions.supplierCodeLike
              ],
              title: '廠編',
              child: (
                <Input
                  name={nameMaster(EnumMaster.supplierCodeLike)}
                  value={inputVal(master[EnumMaster.supplierCodeLike])}
                  onChange={(e) => {
                    setValue(
                      nameMaster(EnumMaster.supplierCodeLike),
                      e.target.value,
                    );
                  }}
                  type="text"
                />
              ),
            },
            { invisible: true },
          ],
        },
        {
          fields: [
            {
              show: retailerSetup?.[EnumRetailerSetup.queryConditions]?.[
                EnumQueryConditions.storeNo
              ],
              title: '分店/倉庫代碼',
              child: (
                <MultiSelect
                  placeholder="可單一選擇或複選"
                  isSearchable
                  {...getErrorHelperText(
                    masterErrorsRoot?.[EnumMaster.storeNo],
                  )}
                  isClearable
                  control={control}
                  name={nameMaster(EnumMaster.storeNo)}
                  value={inputVal(master[EnumMaster.storeNo])}
                  watchValue={() => watch(nameMaster(EnumMaster.storeNo))}
                  options={branchListOpTrs.options}
                />
              ),
            },
            { invisible: true },
          ],
        },
        {
          fields: [
            {
              required: true,
              show: retailerSetup?.[EnumRetailerSetup.queryConditions]?.[
                EnumQueryConditions.orderDate
              ],
              title: '訂單日期',
              child: (
                <DateTimeStartEnd
                  maxDate={DATE_RANGE_CONFIG.maxDate}
                  minDate={DATE_RANGE_CONFIG.minDate}
                  required
                  formReturn={formReturn}
                  startDateName={nameMaster(EnumMaster.orderDateBegin)}
                  endDateName={nameMaster(EnumMaster.orderDateEnd)}
                  startDateError={masterErrorsRoot?.[EnumMaster.orderDateBegin]}
                  endDateError={masterErrorsRoot?.[EnumMaster.orderDateEnd]}
                  isDisabled={isNoViewedPrintChecked}
                />
              ),
            },
            { invisible: true },
          ],
        },
        {
          fields: [
            {
              show: retailerSetup?.[EnumRetailerSetup.queryConditions]?.[
                EnumQueryConditions.deliverDate
              ],
              title: '到貨日期',
              child: (
                <DateTimeStartEnd
                  maxDate={DATE_RANGE_CONFIG.maxDate}
                  minDate={DATE_RANGE_CONFIG.minDate}
                  formReturn={formReturn}
                  startDateName={nameMaster(EnumMaster.deliverDateBegin)}
                  endDateName={nameMaster(EnumMaster.deliverDateEnd)}
                  startDateError={
                    masterErrorsRoot?.[EnumMaster.deliverDateBegin]
                  }
                  endDateError={masterErrorsRoot?.[EnumMaster.deliverDateEnd]}
                />
              ),
            },
            { invisible: true },
          ],
        },
        {
          fields: [
            {
              show:
                !!retailerSetup?.[EnumRetailerSetup.queryConditions]?.[
                  EnumQueryConditions.queryDateSelect
                ] &&
                Object.keys(retailerSetup[EnumRetailerSetup.queryDateList])
                  .length > 0,
              title: '日期類別',
              child: (
                <div className="form-group">
                  <Row>
                    <Col xs={11} sm={11} md={5}>
                      <ReactSelect
                        control={control}
                        {...getErrorHelperText(
                          masterErrorsRoot?.[EnumMaster.queryDateValue],
                        )}
                        name={nameMaster(EnumMaster.queryDateValue)}
                        value={inputVal(master[EnumMaster.queryDateValue])}
                        watchValue={() => watch()}
                        options={queryDateOption}
                        onChange={(newVal) => {
                          // 當下拉選單修改，異動開始日期、結束日期
                          handleQueryDateOptionChange(newVal);
                        }}
                      />
                    </Col>

                    <Col xs={11} sm={11} md={6}>
                      <DateTimeStartEnd
                        maxDate={DATE_RANGE_CONFIG.maxDate}
                        minDate={DATE_RANGE_CONFIG.minDate}
                        required
                        formReturn={formReturn}
                        startDateName={nameMaster(EnumMaster.queryDateBegin)}
                        endDateName={nameMaster(EnumMaster.queryDateEnd)}
                        startDateError={
                          masterErrorsRoot?.[EnumMaster.queryDateBegin]
                        }
                        endDateError={
                          masterErrorsRoot?.[EnumMaster.queryDateEnd]
                        }
                        isDisabled={isNoViewedPrintChecked}
                      />
                    </Col>
                  </Row>
                </div>
              ),
            },
          ],
        },

        {
          fields: [
            {
              show: retailerSetup?.[EnumRetailerSetup.queryConditions]?.[
                EnumQueryConditions.orderNo
              ],
              title: '訂單號碼',
              child: (
                <RangeInput
                  formReturn={formReturn}
                  startName={nameMaster(EnumMaster.orderNoBegin)}
                  endName={nameMaster(EnumMaster.orderNoEnd)}
                  startError={masterErrorsRoot?.orderNoBegin}
                  endError={masterErrorsRoot?.orderNoEnd}
                  isDisable={isNoViewedPrintChecked}
                />
              ),
            },
            { invisible: true },
          ],
        },
        {
          fields: [
            {
              show: true,
              title: '未點閱列印資料',
              child: (
                <Checkbox
                  className="checkbox checkbox-inline"
                  name={nameMaster(EnumMaster.isNoViewedPrintFlag)}
                  label={isNoViewedPrintMessage}
                  onChange={({ target }) =>
                    handleNoViewedPrintOnChange(target.checked)
                  }
                  checked={isNoViewedPrintChecked}
                />
              ),
            },
            { invisible: true },
          ],
        },
        {
          fields: [
            {
              title: '排序',
              child: (
                <div className="form-group">
                  <Row>
                    {masterSort.map((obj, idx) => (
                      <Fragment key={String(idx + 1)}>
                        <Col className="pr-md-0" xs={6} sm={6} md={2}>
                          <ReactSelect
                            control={control}
                            name={nameMasterSort(EnumMasterSort.property, idx)}
                            value={inputVal(
                              masterSort[idx][EnumMasterSort.property],
                            )}
                            watchValue={() =>
                              watch(
                                nameMasterSort(EnumMasterSort.property, idx),
                              )
                            }
                            options={propertyOption}
                          />
                        </Col>
                        <Col className="col-md-auto">
                          <Controller
                            name={nameMasterSort(EnumMasterSort.desc, idx)}
                            control={control}
                            render={({ field: { onChange, value } }) => (
                              <Checkbox
                                className="checkbox checkbox-inline"
                                {...getErrorHelperText(
                                  masterSortErrorsRoot?.[idx]?.desc ||
                                    undefined,
                                )}
                                name={nameMasterSort(EnumMasterSort.desc, idx)}
                                disabled={
                                  masterSort[idx][EnumMasterSort.property] ===
                                  ''
                                }
                                label="由大到小"
                                checked={value as unknown as boolean}
                                onChange={({ target }) =>
                                  onChange(target.checked)
                                }
                              />
                            )}
                          />
                        </Col>
                      </Fragment>
                    ))}
                  </Row>
                </div>
              ),
            },
          ],
        },
      ]}
    />
  );
};
export default QuerySecion;
